import { BaseEntity } from "../../baseEntity";

export class UiAction extends BaseEntity {
  protected readonly ID = "id";

  get id(): string { return this.getInternalValue<string>(this.ID); }
  setId(id: string): this { return this.setInternalValue(this.ID, id); }

}